export const defiEn = {
  defiPage: {
    phase: "Phase 5: DeFi Marketplace",
    title: "Tokenization and Decentralized Finance",
    subtitle: "Invest in tokenized agricultural assets, provide liquidity and participate in staking for sustainable yields.",
    totalLiquidity: "Total Liquidity Locked",
    volume24h: "24h Volume",
    activePools: "Active Pools",
    averageYield: "Average Yield",
    agriculturalTokens: "Agricultural Tokens",
    liquidityPools: "Liquidity Pools",
    staking: "Staking",
    price: "Price",
    marketCap: "Market Cap",
    yieldApy: "Yield APY",
    risk: "Risk",
    buy: "Buy",
    analysis: "Analysis",
    tvl: "TVL",
    rewards: "Rewards",
    addLiquidity: "Add Liquidity",
    stake: "Stake",
    totalStaked: "Total Staked",
    duration: "Duration",
    participants: "participants"
  }
};